import type {ScreenType} from '../types'

export const getHeightSize = (height: number): ScreenType => {
  if (height >= 905) return 'xxl'
  if (height < 905 && height >= 750) return 'xl'
  if (height < 750 && height >= 699) return 'lg'
  if (height < 699 && height >= 630) return 'md'
  if (height < 630 && height >= 530) return 'sm'
  if (height < 530 && height >= 470) return 'xs'
  return 'xxs'
}

export const getOrderHeightSize = (height: number): number => {
  if (height >= 905) return 0
  if (height < 905 && height >= 750) return 1
  if (height < 750 && height >= 699) return 2
  if (height < 699 && height >= 630) return 3
  if (height < 630 && height >= 530) return 4
  if (height < 530 && height >= 470) return 5
  return 6
}
